import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { CommonUIModules } from '@shared/modules';

import { NavigationModule } from '../navigation/navigation.module';
import { LayoutHeaderComponent } from './layout-header.component';

@NgModule({
  imports: [
    // Minga dependencies
    CommonUIModules,
    NavigationModule,

    // External dependencies
    MatMenuModule,
  ],
  declarations: [LayoutHeaderComponent],
  exports: [LayoutHeaderComponent],
})
export class LayoutHeaderModule {}
